import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { useFormik } from 'formik';

import { Agencies, ShiftSourceItems } from '@pharmaplan/common';
import { stub } from '@pharmaplan/common/helpers/utils';

import useSelfService from '../../../hooks/useSelfService';
import CustomDropdown from '../CustomDropdown';

import styles from './styles';

interface IDrawerListHeaderFilter {
  onFilterUpdate: (val: string) => void;
  showFilter: true;
}

interface IDrawerListHeaderWithoutFilter {
  onFilterUpdate?: (val: string) => void;
  showFilter: false;
}

type IDrawerListHeader = (
  | IDrawerListHeaderFilter
  | IDrawerListHeaderWithoutFilter
) & { title: string };

const DrawerListHeader: FC<IDrawerListHeader> = ({
  title,
  onFilterUpdate,
  showFilter = true,
}) => {
  const { isSelfService } = useSelfService();

  const formik = useFormik({
    initialValues: {
      source: isSelfService ? Agencies.PharmaGap : Agencies.PharmaPlan,
    },
    onSubmit: stub,
  });

  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{title}</Typography>
      {showFilter && (
        <Box sx={styles.filterContainer}>
          <CustomDropdown
            onClickMenuItem={onFilterUpdate}
            menuItems={ShiftSourceItems}
            formik={formik}
            name="source"
          />
        </Box>
      )}
      {' '}
    </Box>
  );
};

export default DrawerListHeader;
